<template>
  <div class="summary-section-container">
    <!-- Header Section -->
    <div class="summary-header">
      <div class="avatar-container">
        <img :src="getAvatarSrc" :alt="name || 'EchoCapital'" class="avatar-image">
      </div>
      <div class="header-text">
        <h3 class="entity-name">{{ name || 'ECHO CAPITAL' }}</h3>
        <p class="entity-id"><span style="color: #FFF">144</span>/200</p>
      </div>
    </div>

    <!-- Main Content Section -->
    <div class="summary-main-content">
      <!-- Left Column: 30D PnL and ROI -->
      <div class="main-left-column">
        <div class="pnl-section">
          <p class="pnl-label">30D PnL</p>
          <p class="pnl-value">+ 723 053 USDT</p>
          <p class="roi-value">ROI +5.29%</p>
        </div>
      </div>

      <!-- Right Column: Graph -->
      <div class="main-right-column">
        <img src="../assets/pnl.png" alt="Performance Chart" class="chart-image">
      </div>
    </div>

    <!-- Statistics Row -->
    <div class="statistics-row">
      <div class="stat-item">
        <p class="stat-label">7D PnL</p>
        <p class="stat-value positive">+ 173 791 USDT</p>
      </div>
      <div class="stat-item">
        <p class="stat-label">90D Pnl</p>
        <p class="stat-value positive">+ 2 092 183 USDT</p>
      </div>
      <div class="stat-item">
        <p class="stat-label">AUM</p>
        <p class="stat-value neutral">13 670 113 USDT</p>
      </div>
    </div>
  </div>
</template>

<script>
import defaultAvatar from '../assets/avatar.png'

export default {
  name: 'LandingPageSummarySection',
  props: {
    avatarImage: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'ECHO CAPITAL'
    }
  },
  computed: {
    getAvatarSrc() {
      if (this.avatarImage) {
        // Если это полный URL или путь начинается с /, используем как есть
        if (this.avatarImage.startsWith('http://') || 
            this.avatarImage.startsWith('https://') || 
            this.avatarImage.startsWith('/')) {
          return this.avatarImage
        }
        // Иначе пытаемся использовать как относительный путь
        return this.avatarImage
      }
      return defaultAvatar
    }
  }
}
</script>

<style scoped>
.summary-section-container {
  border:1px solid rgb(64,64,64);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.summary-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.avatar-container {
  position: relative;
  width: 80px;
  height: 80px;
  flex-shrink: 0;
}

.avatar-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(0, 255, 0, 0.2);
  object-fit: cover;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.entity-name {
  font-size: 24px;
  font-weight: 600;
  color: #FFFFFF;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

.entity-id {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.summary-main-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: center;
}

.main-left-column {
  display: flex;
  flex-direction: column;
}

.pnl-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pnl-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.pnl-value {
  font-size: 32px;
  font-weight: 700;
  color: rgb(80, 210, 193);
  margin: 0;
  line-height: 1.2;
}

.roi-value {
  font-size: 16px;
  color: rgb(80, 210, 193);
  margin: 0;
}

.main-right-column {
  width: 100%;
  height: 100%;
  min-height: 200px;
}

.chart-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.statistics-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding-top: 16px;
  border-top: 1px solid #2A2A2A;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.stat-value {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.stat-value.positive {
  color: rgb(80, 210, 193);
}

.stat-value.neutral {
  color: #FFFFFF;
}

.copy-button {
  width: 100%;

}

.copy-button:hover {
  opacity: 0.9;
}

.copy-button:active {
  opacity: 0.8;
}

@media (max-width: 768px) {
  .summary-section-container {
    padding: 16px;
    gap: 16px;
  }

  .avatar-container {
    width: 60px;
    height: 60px;
  }

  .entity-name {
    font-size: 20px;
  }

  .summary-main-content {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .pnl-value {
    font-size: 28px;
  }

  .statistics-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .main-right-column {
    min-height: 150px;
  }
}
</style>
